<template>
  <section>
    <!--工具条（按钮权限由后台配置，如"查询" Func=onSearch）-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--筛选区：姓名 / 身份证号 / 生成时间范围 / 打印状态-->
    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="姓名">
        <el-input v-model="filters.userName" placeholder="用户姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="filters.idCardNo" placeholder="身份证号" clearable></el-input>
      </el-form-item>
      <el-form-item label="类别">
        <el-select v-model="filters.type" placeholder="全部" clearable style="width: 130px">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="打印状态">
        <el-select v-model="filters.isPrinted" placeholder="全部" clearable style="width: 110px">
          <el-option label="已打印" :value="true"></el-option>
          <el-option label="未打印" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生成时间">
        <el-date-picker
          v-model="timeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!--报告生成记录列表（终端生成，管理端只读）-->
    <el-table :data="lists" v-loading="listLoading" style="width: 100%" ref="table" class="custom-tbl">
      <el-table-column prop="ReportNo" label="报告编号" width="210" show-overflow-tooltip></el-table-column>
      <el-table-column prop="UserName" label="姓名" width="100" sortable></el-table-column>
      <el-table-column prop="IdCardNo" label="身份证号" width="190"></el-table-column>
      <el-table-column prop="GroupName" label="分组名称" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="Type" label="类别" width="120" :formatter="formatType"></el-table-column>
      <el-table-column prop="Question" label="咨询问题" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column label="生成状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsSuccess ? 'success' : 'danger'" size="mini" disable-transitions>
            {{ scope.row.IsSuccess ? "成功" : "失败" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="生成时间" :formatter="formatCreateTime" width="170" sortable>
      </el-table-column>
      <el-table-column label="打印状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsPrinted ? 'success' : 'info'" size="mini" disable-transitions>
            {{ scope.row.IsPrinted ? "已打印" : "未打印" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="PrintCount" label="打印次数" width="90" sortable></el-table-column>
      <el-table-column prop="LastPrintTime" label="最后打印时间" :formatter="formatLastPrintTime" width="170">
      </el-table-column>
      <el-table-column label="操作" width="110" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.IsSuccess && scope.row.PdfUrl"
            type="primary"
            size="small"
            @click="handleViewReport(scope.row)">查看报告</el-button>
          <span v-else class="no-report">-</span>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next, total" @current-change="handleCurrentChange" :page-size="pagesize"
        :total="total" style="float: right">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getAIReportPage } from "../../api/api";
import { BaseApiUrl } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      //类别（1=法律问题咨询 2=事实界定分析 3=举证质证指引 4=诉讼策略生成）
      typeOptions: [
        { value: 1, label: "法律问题咨询" },
        { value: 2, label: "事实界定分析" },
        { value: 3, label: "举证质证指引" },
        { value: 4, label: "诉讼策略生成" },
      ],
      filters: {
        userName: "",
        idCardNo: "",
        isPrinted: null,
        type: null,
      },
      timeRange: null,
      lists: [],
      total: 0,
      page: 1,
      pagesize: 20,
      listLoading: false,
    };
  },
  methods: {
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
    onReset() {
      this.filters = { userName: "", idCardNo: "", isPrinted: null, type: null };
      this.timeRange = null;
      this.page = 1;
      this.getList();
    },
    //类别数字转名称
    formatType: function (row) {
      let item = this.typeOptions.find((t) => t.value === row.Type);
      return item ? item.label : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd hh:mm:ss");
    },
    formatLastPrintTime: function (row, column) {
      return !row.LastPrintTime || row.LastPrintTime == ""
        ? ""
        : util.formatDate.format(new Date(row.LastPrintTime), "yyyy-MM-dd hh:mm:ss");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取报告生成记录分页
    getList() {
      let para = {
        page: this.page,
        size: this.pagesize,
        userName: this.filters.userName || "",
        idCardNo: this.filters.idCardNo || "",
        beginTime: this.timeRange && this.timeRange[0] ? this.timeRange[0] + " 00:00:00" : null,
        endTime: this.timeRange && this.timeRange[1] ? this.timeRange[1] + " 23:59:59" : null,
        isPrinted: this.filters.isPrinted === null || this.filters.isPrinted === "" ? null : this.filters.isPrinted,
        type: this.filters.type || 0,
      };
      this.listLoading = true;
      getAIReportPage(para).then((res) => {
        if (res.data.response != null) {
          var result = res.data.response;
          this.total = result.dataCount;
          this.pagesize = result.PageSize;
          this.lists = result.data;
        }
        this.listLoading = false;
      }).catch(() => {
        this.listLoading = false;
      });
    },
    //查看报告（PDF 静态资源，新窗口打开；超过 24 小时文件已清理会 404）
    handleViewReport(row) {
      if (!row.PdfUrl) {
        this.$message({ message: "该报告无 PDF 文件", type: "warning" });
        return;
      }
      window.open(BaseApiUrl + row.PdfUrl, "_blank");
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.filter-form {
  margin-top: 10px;
}

.no-report {
  color: #c0c4cc;
}
</style>
